export enum MenuActions {
  Enable = 'enable',
  Disable = 'disable',
  Delete = 'delete',
  Clone = 'clone',
}
